<div class="flex justify-center">
    <h2 class="font-light leading-relaxed text-3xl py-8 text-gray-800 cursor-default"
        style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Transformation Journey</h2>
</div>
<div class="w-5/6 px-8 mx-auto">
    <div class="shadow">
        <div class="border-b">
            <div class="border-l-2 border-transparent">
                <ng-container *ngFor="let meta of metas;">
                    <div class="grid grid-cols-1 p-1 text-justify">
                        <div class="flex justify-between text-xl px-2 py-1 font-light bg-gradient-to-t from-headerfr to-headerto text-yellow-200 rounded-md cursor-pointer"
                            (click)="onClick($event.target.value)" value="{{meta.Meta}}">
                            {{meta.Meta}}
                            <div class="rounded-full border border-grey w-6 h-6 flex items-center justify-center pointer-events-none"
                                *ngIf="!meta.expanded">
                                <svg aria-hidden="true" data-reactid="266" fill="none" height="24" stroke="#f7f4df"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24"
                                    width="24" xmlns="http://www.w3.org/2000/svg">
                                    <polyline points="6 9 12 15 18 9">
                                    </polyline>
                                </svg>
                            </div>
                            <div class="rounded-full border border-grey w-6 h-6 flex items-center justify-center pointer-events-none"
                                *ngIf="meta.expanded">
                                <svg aria-hidden="true" data-reactid="266" fill="none" height="24" stroke="#f7f4df"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24"
                                    width="24" xmlns="http://www.w3.org/2000/svg">
                                    <polyline points="18 15 12 9 6 15">
                                    </polyline>
                                </svg>
                            </div>
                        </div>
                        <div *ngIf="meta.expanded">
                            <div *ngFor="let question of questions;">
                                <div class="shadow">
                                    <div class="border-b">
                                        <div class="border-l-2 border-transparent">
                                            <div class="p-1 text-lg font-thin rounded hover:bg-colortext hover:text-yellow-200 cursor-pointer"
                                                (click)="onLqClick(question)">
                                                {{ question.LQ }}
                                            </div>
                                            <div *ngIf="question.expanded && question.cities && question.cities.length">
                                                <div class="p-1 text-base text-lg font-thin text-gray-700">Cities:</div>
                                                <div class="ml-6">
                                                    <div *ngFor="let city of question.cities"
                                                        class="p-1 text-base font-thin text-gray-700 hover:text-yellow-600 rounded cursor-pointer"
                                                        (click)="onCity(city)">
                                                        {{ city.City }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>